import React from 'react';
import ArchivesFacturation from '../facturation/ArchivesFacturation';
import { ARCHIVE_MODULE_INVENTAIRE } from '../facturation/utils/archiveModuleScope';

/** Archives Inventaire — même UI que Facturation, filtre module inventaire (stock). */
const ArchivesInventaire = () => (
  <ArchivesFacturation moduleScope={ARCHIVE_MODULE_INVENTAIRE} />
);

export default ArchivesInventaire;
